import { render, staticRenderFns } from "./ApiDetailView.vue?vue&type=template&id=0de4e977&scoped=true"
import script from "./ApiDetailView.vue?vue&type=script&lang=js"
export * from "./ApiDetailView.vue?vue&type=script&lang=js"
import style0 from "./ApiDetailView.vue?vue&type=style&index=0&id=0de4e977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4e977",
  null
  
)

export default component.exports